import { LoadingOutlined } from '@ant-design/icons';
import { Modal, Result } from 'antd';
import React from 'react';

const ModalLoading = ({
  open,
  icon = <LoadingOutlined />,
  title,
  subTitle
}) => {
  return (
    <Modal
      title={null}
      open={open}
      footer={null}
      closable={false}
      bodyStyle={{ padding: 0 }}
      wrapClassName="vertical-center-modal"
    >
      <Result
        icon={icon}
        title={title}
        subTitle={
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              whiteSpace: 'normal'
            }}
          >
            {subTitle}
          </div>
        }
      />
    </Modal>
  );
};

export default ModalLoading;
